import { RtError } from '@core/utils-legacy';

/** Exception thrown when a tooltip has an invalid position. */
export class RtTooltipInvalidPositionError extends RtError {
  constructor(position: string) {
    super('TooltipInvalidPositionError', `Tooltip position "${position}" is invalid.`);
  }
}
